export const USERNOTE_EL_CONNECTION_NEEDED = 'CSC Interrupted: EL connection needed'
export const USERNOTE_I_HAVE_DANGEROUS_GOODS = 'CSC Interrupted: Contains unbooked IMO'
export const USERNOTE_MORE_THAN_ONE_PASSENGER = 'CSC Interrupted: Number of drivers doesn\'t match'
export const USERNOTE_CHECKIN_BATCH_SERVER = 'CSC Interrupted: Res locked by BATCH server'
